import { motion } from "framer-motion";
import { ArrowUpRight, Factory, Hammer, Layers, Users } from "lucide-react";
import { Reveal, SectionHeading, EASE } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";
import { useLang } from "@/lib/i18n";

const IMGS = [
  "https://customer-assets-agu9un31.emergentagent.net/job_carpenter-pro-forte/artifacts/ll3kqblz_WhatsApp%20Image%202026-09-13%20at%2007.08.52.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_carpenter-pro-forte/artifacts/zba486yd_WhatsApp%20Image%202026-09-13%20at%2007.20.30.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_carpenter-pro-forte/artifacts/6yccejj8_WhatsApp%20Image%202026-09-13%20at%2007.08.18.jpeg",
  "https://customer-assets-agu9un31.emergentagent.net/job_carpenter-pro-forte/artifacts/sq822778_WhatsApp%20Image%202026-09-13%20at%2007.09.21.jpeg",
];
const ICONS = [Hammer, Layers, Users, Factory];
const TESTIDS = [
  "service-card-carpenteria",
  "service-card-ferro",
  "service-card-manovalanza",
  "service-card-prefabbricazione",
];

export default function Servizi() {
  const { t } = useLang();
  const s = t.services;

  return (
    <section id="servizi" className="relative border-t border-[#272B36] bg-[#0F1115] py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeading
          overline={s.overline}
          title={s.title}
          description={s.desc}
          testid="services-section-title"
        />
        <div className="grid gap-6 md:grid-cols-2">
          {s.items.map((item, i) => {
            const Icon = ICONS[i];
            const testid = TESTIDS[i];
            return (
              <Reveal key={testid} delay={i * 0.08}>
                <motion.article
                  data-testid={testid}
                  whileHover={{ y: -6 }}
                  transition={{ duration: 0.3, ease: EASE }}
                  className="group flex h-full flex-col border border-[#272B36] bg-[#181B22] transition-colors duration-300 hover:border-[#F97316]/60"
                >
                  <div className="relative h-44 overflow-hidden">
                    <img
                      src={IMGS[i]}
                      alt={item.alt}
                      loading="lazy"
                      className="h-full w-full object-cover opacity-70 saturate-[0.55] transition duration-500 group-hover:scale-105 group-hover:opacity-100 group-hover:saturate-100"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#181B22] via-transparent to-transparent" />
                    <span className="absolute left-5 top-5 border border-[#383E4E] bg-[#0D0E11]/85 px-2.5 py-1 font-mono-tech text-xs font-bold text-[#F97316] backdrop-blur">
                      0{i + 1}
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-7">
                    <Icon className="mb-5 h-8 w-8 text-[#F97316]" strokeWidth={1.5} />
                    <h3 className="font-display text-2xl font-bold uppercase leading-tight tracking-tight text-[#F8FAFC] sm:text-3xl">
                      {item.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-[#94A3B8]">{item.desc}</p>
                    <ul className="mt-5 space-y-2">
                      {item.points.map((p) => (
                        <li key={p} className="flex items-center gap-3 text-sm text-[#94A3B8]">
                          <span className="h-1.5 w-1.5 rotate-45 bg-[#E65100]" aria-hidden="true" />
                          {p}
                        </li>
                      ))}
                    </ul>
                    <button
                      data-testid={`${testid}-inquiry-link`}
                      onClick={() => scrollToId("#contatti")}
                      className="mt-auto flex items-center gap-2 pt-7 font-mono-tech text-xs font-bold uppercase tracking-[0.18em] text-[#64748B] transition-colors group-hover:text-[#F97316]"
                    >
                      {s.cta}
                      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </button>
                  </div>
                </motion.article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
